import React, { useState, useEffect } from "react";

import { Col, Form } from 'react-bootstrap';

import { useTranslation } from "react-i18next";

function PivotForm(props) {
  const { t, i18n } = useTranslation();

  return (
    <>
      <Col md="12" className="form-group">
        <Form.Group controlId="irrig-pivot-shape">
          <Form.Label>{t('pivot_shape')}</Form.Label>
          <Form.Select value={props.pivot_shape} onChange={props.handlePivotShape}>
            <option value="circular">Circular</option>
            <option value="semi_circular">Semi-Circular</option>
          </Form.Select>
        </Form.Group>
      </Col>
      <Col md="12" className="form-group">
        <p style={{ marginBottom: "10px" }}>{t('Irrigation_system_calculations')}</p>
        <div
          className="d-flex justify-content-around align-items-center"
          onChange={props.handleIrrgSyst}
        >
          <Form.Check
            type="radio"
            id="irrig-pivot-syst-flowrate"
            name="IrrigationSys"
            value="flowrate"
            label={t('by_flowrate')}
          />
          <Form.Check
            type="radio"
            id="irrig-pivot-syst-depth"
            name="IrrigationSys"
            value="depth"
            label={t('by_depth')}
          />
        </div>
      </Col>

      <Col md="12" className="form-group">
        <Form.Group controlId="irrig-pivot-name">
          <Form.Label>{t('name')}</Form.Label>
          <Form.Control placeholder={t('name')} required onChange={props.handleName} />
        </Form.Group>
      </Col>
      <Col md="6" className="form-group">
        <Form.Group controlId="irrig-pivot-length">
          <Form.Label>{t('pivot_length')}</Form.Label>
          <Form.Control
          type="number"
            value={props.pivot_length}
            placeholder={t('pivot_length')}
            required
            onChange={props.handlePivotLength}
          />
        </Form.Group>
      </Col>
      <Col md="5" className="form-group">
        <Form.Group controlId="irrig-pivot-coord">
          <Form.Label>{t('pivot_center_coordinates')}</Form.Label>
          <Form.Control
          type="number"
            value={props.pivot_coord}
            placeholder={t('pivot_center_coordinates')}
            required
            onChange={props.handlePivotCoord}
          />
        </Form.Group>
      </Col>
      <Col md="6" className="form-group">
        <Form.Group controlId="irrig-pivot-flowrate">
          <Form.Label>{t('FlowRate')}</Form.Label>
          <Form.Control
          type="number"
            value={props.flowrate}
            placeholder={t('FlowRate')}
            required
            onChange={props.handleFlowRate}
          />
        </Form.Group>
      </Col>
      <Col md="6" className="form-group">
        <Form.Group controlId="irrig-pivot-runtime">
          <Form.Label>{t('full_run_time')}</Form.Label>
          <Form.Control
            value={props.full_runtime}
            placeholder={t('full_run_time')}
            required
            onChange={props.handleRunTime}
          />
        </Form.Group>
      </Col>
    </>
  );
}

export default PivotForm;
